// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lead-details-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  overflow-y: auto;
  padding: 20px;
}

.lead-details-container {
  background: white;
  border-radius: 15px;
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.lead-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px 15px 0 0;
}

.header-left h2 {
  margin: 0 0 5px 0;
  font-size: 24px;
}

.lead-id {
  font-size: 14px;
  opacity: 0.9;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
}

/* Tabs */
.tabs {
  display: flex;
  background: #f5f6fa;
  border-bottom: 2px solid #e0e0e0;
  padding: 0 25px;
}

.tab {
  padding: 15px 25px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #7f8c8d;
  border-bottom: 3px solid transparent;
  transition: all 0.3s;
  margin-bottom: -2px;
}

.tab:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background: white;
}

/* Content */
.lead-details-content {
  padding: 25px;
  overflow-y: auto;
  flex: 1 1;
}

/* Overview Tab */
.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.detail-item label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #7f8c8d;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}

.detail-item p {
  font-size: 15px;
  color: #2c3e50;
  margin: 0;
  font-weight: 500;
}

.detail-section {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.detail-section label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #7f8c8d;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.detail-section p {
  margin: 0;
  color: #2c3e50;
  line-height: 1.6;
}

/* Badges */
.badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-new { background: #3498db; color: white; }
.badge-follow-up { background: #f39c12; color: white; }
.badge-hot { background: #e74c3c; color: white; }
.badge-cold { background: #95a5a6; color: white; }
.badge-converted { background: #27ae60; color: white; }
.badge-lost { background: #c0392b; color: white; }
.badge-meeting { background: #9b59b6; color: white; }
.badge-not-picked-up { background: #f1c40f; color: white; }
.badge-not-interested { background: #7f8c8d; color: white; }
.badge-interested { background: #2ecc71; color: white; }
.badge-switch-off { background: #d35400; color: white; }
.badge-invalid { background: #7f8c8d; color: white; }
.badge-busy { background: #e67e22; color: white; }
.badge-call-cut { background: #c0392b; color: white; }
.badge-stage { background: #3498db; color: white; }
.badge-priority-low { background: #ecf0f1; color: #7f8c8d; }
.badge-priority-medium { background: #f39c12; color: white; }
.badge-priority-high { background: #e74c3c; color: white; }
.badge-priority-critical { background: #c0392b; color: white; }

/* Forms */
.followup-form,
.communication-form,
.note-form {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.form-check input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.form-check label {
  margin: 0;
  cursor: pointer;
  font-size: 14px;
}

/* Timeline */
.timeline {
  position: relative;
  padding-left: 30px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e0e0e0;
}

.timeline-item {
  position: relative;
  margin-bottom: 25px;
  padding-bottom: 25px;
}

.timeline-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -26px;
  top: 5px;
  width: 16px;
  height: 16px;
  background: #667eea;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #667eea;
}

.comm-marker {
  background: #27ae60;
  box-shadow: 0 0 0 2px #27ae60;
}

.timeline-item.status-completed .timeline-marker {
  background: #27ae60;
  box-shadow: 0 0 0 2px #27ae60;
}

.timeline-item.status-missed .timeline-marker {
  background: #e74c3c;
  box-shadow: 0 0 0 2px #e74c3c;
}

.timeline-content {
  background: white;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.timeline-date {
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 500;
}

.comm-type {
  display: inline-block;
  padding: 4px 10px;
  background: #27ae60;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.pending {
  background: #f39c12;
  color: white;
}

.status-badge.completed {
  background: #27ae60;
  color: white;
}

.status-badge.missed {
  background: #e74c3c;
  color: white;
}

.timeline-content h4 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 16px;
}

.timeline-content p {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
  line-height: 1.5;
}

.assigned-info,
.recorded-by {
  display: block;
  margin-top: 10px;
  font-size: 12px;
  color: #95a5a6;
  font-style: italic;
}

/* Notes Grid */
.notes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.note-card {
  background: #fffbea;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #f39c12;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  position: relative;
}

.note-card.important {
  background: #ffebee;
  border-left-color: #e74c3c;
}

.important-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  background: #e74c3c;
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

.note-card p {
  margin: 0 0 10px 0;
  color: #2c3e50;
  line-height: 1.6;
}

.note-footer small {
  color: #95a5a6;
  font-size: 12px;
}

/* Sections */
.add-followup-section,
.add-communication-section,
.add-note-section {
  margin-bottom: 30px;
}

.add-followup-section h3,
.add-communication-section h3,
.add-note-section h3,
.followups-list h3,
.communication-list h3,
.notes-list h3 {
  font-size: 18px;
  color: #2c3e50;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* No Data */
.no-data {
  text-align: center;
  padding: 40px;
  color: #95a5a6;
  font-style: italic;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .details-grid {
    grid-template-columns: 1fr;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .tabs {
    overflow-x: auto;
    padding: 0 15px;
  }
  
  .tab {
    padding: 12px 15px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  .lead-details-content {
    padding: 15px;
  }
  
  .notes-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,aAAa,mBAAmB,EAAE,YAAY,EAAE;AAChD,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,aAAa,mBAAmB,EAAE,YAAY,EAAE;AAChD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;AACrD,eAAe,mBAAmB,EAAE,YAAY,EAAE;AAClD,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE,YAAY,EAAE;;AAE9D,UAAU;AACV;;;EAGE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;EAME,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".lead-details-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.lead-details-container {\n  background: white;\n  border-radius: 15px;\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n}\n\n.lead-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px 15px 0 0;\n}\n\n.header-left h2 {\n  margin: 0 0 5px 0;\n  font-size: 24px;\n}\n\n.lead-id {\n  font-size: 14px;\n  opacity: 0.9;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  background: #f5f6fa;\n  border-bottom: 2px solid #e0e0e0;\n  padding: 0 25px;\n}\n\n.tab {\n  padding: 15px 25px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: #7f8c8d;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s;\n  margin-bottom: -2px;\n}\n\n.tab:hover {\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.1);\n}\n\n.tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  background: white;\n}\n\n/* Content */\n.lead-details-content {\n  padding: 25px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Overview Tab */\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.detail-item label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #7f8c8d;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n  letter-spacing: 0.5px;\n}\n\n.detail-item p {\n  font-size: 15px;\n  color: #2c3e50;\n  margin: 0;\n  font-weight: 500;\n}\n\n.detail-section {\n  margin-top: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.detail-section label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #7f8c8d;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.detail-section p {\n  margin: 0;\n  color: #2c3e50;\n  line-height: 1.6;\n}\n\n/* Badges */\n.badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.badge-new { background: #3498db; color: white; }\n.badge-follow-up { background: #f39c12; color: white; }\n.badge-hot { background: #e74c3c; color: white; }\n.badge-cold { background: #95a5a6; color: white; }\n.badge-converted { background: #27ae60; color: white; }\n.badge-lost { background: #c0392b; color: white; }\n.badge-meeting { background: #9b59b6; color: white; }\n.badge-not-picked-up { background: #f1c40f; color: white; }\n.badge-not-interested { background: #7f8c8d; color: white; }\n.badge-interested { background: #2ecc71; color: white; }\n.badge-switch-off { background: #d35400; color: white; }\n.badge-invalid { background: #7f8c8d; color: white; }\n.badge-busy { background: #e67e22; color: white; }\n.badge-call-cut { background: #c0392b; color: white; }\n.badge-stage { background: #3498db; color: white; }\n.badge-priority-low { background: #ecf0f1; color: #7f8c8d; }\n.badge-priority-medium { background: #f39c12; color: white; }\n.badge-priority-high { background: #e74c3c; color: white; }\n.badge-priority-critical { background: #c0392b; color: white; }\n\n/* Forms */\n.followup-form,\n.communication-form,\n.note-form {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 30px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 8px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.form-check input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.form-check label {\n  margin: 0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Timeline */\n.timeline {\n  position: relative;\n  padding-left: 30px;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  left: 8px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #e0e0e0;\n}\n\n.timeline-item {\n  position: relative;\n  margin-bottom: 25px;\n  padding-bottom: 25px;\n}\n\n.timeline-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.timeline-marker {\n  position: absolute;\n  left: -26px;\n  top: 5px;\n  width: 16px;\n  height: 16px;\n  background: #667eea;\n  border-radius: 50%;\n  border: 3px solid white;\n  box-shadow: 0 0 0 2px #667eea;\n}\n\n.comm-marker {\n  background: #27ae60;\n  box-shadow: 0 0 0 2px #27ae60;\n}\n\n.timeline-item.status-completed .timeline-marker {\n  background: #27ae60;\n  box-shadow: 0 0 0 2px #27ae60;\n}\n\n.timeline-item.status-missed .timeline-marker {\n  background: #e74c3c;\n  box-shadow: 0 0 0 2px #e74c3c;\n}\n\n.timeline-content {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.timeline-date {\n  font-size: 13px;\n  color: #7f8c8d;\n  font-weight: 500;\n}\n\n.comm-type {\n  display: inline-block;\n  padding: 4px 10px;\n  background: #27ae60;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.pending {\n  background: #f39c12;\n  color: white;\n}\n\n.status-badge.completed {\n  background: #27ae60;\n  color: white;\n}\n\n.status-badge.missed {\n  background: #e74c3c;\n  color: white;\n}\n\n.timeline-content h4 {\n  margin: 0 0 8px 0;\n  color: #2c3e50;\n  font-size: 16px;\n}\n\n.timeline-content p {\n  margin: 0;\n  color: #7f8c8d;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.assigned-info,\n.recorded-by {\n  display: block;\n  margin-top: 10px;\n  font-size: 12px;\n  color: #95a5a6;\n  font-style: italic;\n}\n\n/* Notes Grid */\n.notes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.note-card {\n  background: #fffbea;\n  padding: 15px;\n  border-radius: 8px;\n  border-left: 4px solid #f39c12;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.note-card.important {\n  background: #ffebee;\n  border-left-color: #e74c3c;\n}\n\n.important-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 12px;\n  background: #e74c3c;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n\n.note-card p {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  line-height: 1.6;\n}\n\n.note-footer small {\n  color: #95a5a6;\n  font-size: 12px;\n}\n\n/* Sections */\n.add-followup-section,\n.add-communication-section,\n.add-note-section {\n  margin-bottom: 30px;\n}\n\n.add-followup-section h3,\n.add-communication-section h3,\n.add-note-section h3,\n.followups-list h3,\n.communication-list h3,\n.notes-list h3 {\n  font-size: 18px;\n  color: #2c3e50;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* No Data */\n.no-data {\n  text-align: center;\n  padding: 40px;\n  color: #95a5a6;\n  font-style: italic;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .tabs {\n    overflow-x: auto;\n    padding: 0 15px;\n  }\n  \n  .tab {\n    padding: 12px 15px;\n    font-size: 12px;\n    white-space: nowrap;\n  }\n  \n  .lead-details-content {\n    padding: 15px;\n  }\n  \n  .notes-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
